import "./whyGlobalCapability.css";

const benefits = [
  {
    number: "01",
    title: "Flexible Engagement",
    description:
      "Choose a service model aligned with your scope, priorities, and operational requirements.",
  },
  {
    number: "02",
    title: "Specialized Support",
    description:
      "Access relevant skills and process support based on the needs of your business.",
  },
  {
    number: "03",
    title: "Operational Focus",
    description:
      "Create clearer ownership for agreed tasks, workflows, and delivery expectations.",
  },
  {
    number: "04",
    title: "Scalable Approach",
    description:
      "Review and adapt the engagement as your needs evolve.",
  },
];

export default function WhyGlobalCapability() {
  return (
    <section className="why-global-capability">
      <div className="why-global-capability__container">
        <header className="why-global-capability__header">
          <span className="why-global-capability__eyebrow">
            <span
              className="why-global-capability__eyebrow-dot"
              aria-hidden="true"
            />
            WHY GLOBAL CAPABILITY SERVICES
          </span>

          <h2 className="why-global-capability__title">
            Flexible Support for
            <br />
            <span>Complex Business Needs</span>
          </h2>
        </header>

        <div className="why-global-capability__grid">
          {benefits.map((benefit) => (
            <article
              className="why-global-capability__card"
              key={benefit.number}
            >
              <div className="why-global-capability__card-top">
                <span className="why-global-capability__number">
                  {benefit.number}
                </span>

                <span
                  className="why-global-capability__card-marker"
                  aria-hidden="true"
                />
              </div>

              <div className="why-global-capability__card-content">
                <h3 className="why-global-capability__card-title">
                  {benefit.title}
                </h3>

                <p className="why-global-capability__description">
                  {benefit.description}
                </p>
              </div>

              <span
                className="why-global-capability__accent"
                aria-hidden="true"
              />
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}